import { IHistoryState } from './history-states.store';
import { GetterTree } from 'vuex';

const getters: GetterTree<IHistoryState, any> = <GetterTree<IHistoryState, any>>{
  service: (state: IHistoryState) => state.service,
  source: (state: IHistoryState) => {
    return state.source
  }
}

export default getters